import React from 'react';
import {BrowserRouter, Link, Route, Routes} from "react-router-dom";
import {Container, Nav, Navbar} from 'react-bootstrap';
import HomePage from "./pages/HomePage";
import GeneralTermsAndConditions from "./pages/GeneralTermsAndConditions";
import RulesOfOperationPage from "./pages/RulesOfOperationPage";
import GdprPage from "./pages/GdprPage";
import PricesPage from "./pages/PricesPage";
import ContactPage from "./pages/ContactPage";
import InBodyScanConsent from "./pages/InBodyScanConsent";
import logo from './assets/logo.png';

function App() {
    return (
        <>
            <BrowserRouter>
                <Navbar bg="black" className={'py-3'} variant="dark" expand="md" collapseOnSelect
                        fixed="top">
                    <Container>
                        <Navbar.Brand as={Link} to="/" className={'px-3'}>
                            <img
                                src={logo}
                                alt="MyApp Logo"
                                height="50"
                                className="d-inline-block align-top"
                            /></Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav"/>

                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Link href={"/"}>Home</Nav.Link>
                                <Nav.Link href={"/contact"}>Kontakt</Nav.Link>
                                <Nav.Link href={"/prices"}>Cenník</Nav.Link>
                                <Nav.Link href={"/gdpr"}>GDPR</Nav.Link>
                                <Nav.Link href={"/rules-of-operation"}>Prevádzkový poriadok</Nav.Link>
                                <Nav.Link href={"/general-terms-and-conditions"}>VOP</Nav.Link>
                                <Nav.Link href={"/inbody-consent"}>Súhlas InBody</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Container style={{padding: '50px'}}>
                    <Routes>
                        <Route index={true} element={<HomePage/>}/>
                        <Route path="/contact" element={<ContactPage/>}/>
                        <Route path="/prices" element={<PricesPage/>}/>
                        <Route path="/gdpr" element={<GdprPage/>}/>
                        <Route path="/rules-of-operation" element={<RulesOfOperationPage/>}/>
                        <Route path="/general-terms-and-conditions" element={<GeneralTermsAndConditions/>}/>
                        <Route path="/inbody-consent" element={<InBodyScanConsent/>}/>
                    </Routes>
                </Container>
            </BrowserRouter>
        </>
    );
}

export default App;
